import * as React from "react";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";

type ErrorFallbackProps = {
  error: Error;
  title: string;
  resetErrorBoundary(): void;
};

function ErrorFallback({
  error,
  title,
  resetErrorBoundary,
}: ErrorFallbackProps) {
  return (
    <div role="alert">
      <p>Something went wrong in {title}:</p>
      <pre>{error.message}</pre>
      <button className="border border-black p-2 rounded" onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
}

type ErrorBoundaryProps = {
  children: React.ReactNode;
  title: string;
};

export function ErrorBoundary({ children, title }: ErrorBoundaryProps) {
  return (
    <ReactErrorBoundary
      fallbackRender={(error, resetErrorBoundary) => (
        <ErrorFallback
          error={error}
          resetErrorBoundary={resetErrorBoundary}
          title={title}
        />
      )}
    >
      {children}
    </ReactErrorBoundary>
  );
}
